var _g, _path, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 47,
    height: 49,
    viewBox: "0 0 47 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3076_238468)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.5001 42.86C34.9213 42.86 44.1801 33.6013 44.1801 22.18C44.1801 10.7588 34.9213 1.5 23.5001 1.5C12.0788 1.5 2.82007 10.7588 2.82007 22.18C2.82007 28.6109 5.7555 34.3563 10.3596 38.1492C10.3669 38.1552 10.3604 38.1669 10.3514 38.1639V38.1639C10.3458 38.162 10.3401 38.1661 10.3401 38.1719V42.9452C10.3401 45.4929 13.0254 47.1464 15.3003 45.9996L20.6696 43.293C21.333 42.9586 22.0763 42.825 22.8189 42.849C23.045 42.8563 23.2721 42.86 23.5001 42.86Z",
    fill: "#3F62A1"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.48 15.16C22.6907 15.16 22.0293 14.9147 21.496 14.424C20.984 13.912 20.728 13.2827 20.728 12.536C20.728 11.7893 20.984 11.1707 21.496 10.68C22.0293 10.168 22.6907 9.912 23.48 9.912C24.2693 9.912 24.92 10.168 25.432 10.68C25.9653 11.1707 26.232 11.7893 26.232 12.536C26.232 13.2827 25.9653 13.912 25.432 14.424C24.92 14.9147 24.2693 15.16 23.48 15.16ZM25.688 17.272V35H21.208V17.272H25.688Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3076_238468"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47,
    height: 47,
    fill: "white",
    transform: "translate(0 1.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.718af64434dcde19e3995521ea5619d0.svg";
export { ForwardRef as ReactComponent };